function copyEmail(btn, email) {
  const addr = email || 'demo@allsync.io';
  navigator.clipboard.writeText(addr).then(() => {
    const orig = btn.textContent;
    btn.textContent = '✓ Copied!';
    setTimeout(() => btn.textContent = orig, 2000);
  });
}

// ─── CHATBOT ─────────────────────────────────────────────────────────────
let chatOpen = false;
const BOT = {
  connector:"We support MS-SQL, Oracle, HANA, MySQL, REST API, Email (SMTP/IMAP), AWS S3, SFTP, and more. All pre-built and ready to activate! 🔌",
  demo:"Email us at **demo@allsync.io** with your name, company, and systems to integrate. We reply within 24h! 📅",
  pricing:"Pricing depends on integration volume and connectors needed. Email demo@allsync.io for a custom quote. 💰",
  ai:"AllSync AI auto-suggests field mappings, parses email content, and detects anomalies in real-time — saving 80% setup time! 🧠",
  sap:"Deep connectors for SAP Business One and SAP S/4HANA via Service Layer — sync products, customers, orders, inventory. ✅",
  shopify:"Ready Shopify connector for syncing orders, inventory, and customers to your ERP in real-time. 🛒",
  "no code":"AllSync provides visual drag-and-drop so anyone can build integrations without any coding. 🎨",
  dynamics:"Yes! Full Microsoft Dynamics 365 Business Central connector supporting product sync, customer data, and order management. ✅",
  hello:"Hello! 👋 Ask me about connectors, AI features, pricing, or how to request a demo.",
  hi:"Hi there! 👋 I'm here to help with questions about AllSync.",
  help:"I can answer questions about: connectors, AI features, pricing, demo requests, or success stories.",
  default:"Great question! For detailed help, email **demo@allsync.io** and we'll respond within 24h. 😊"
};

function toggleChat() {
  chatOpen = !chatOpen;
  document.getElementById('chatbot-window').classList.toggle('open', chatOpen);
  document.getElementById('chat-icon').textContent = chatOpen ? '✕' : '💬';
  if (chatOpen) {
    document.getElementById('chat-notif').style.display = 'none';
    setTimeout(() => document.getElementById('chatInput').focus(), 300);
  }
}

function getBotReply(msg) {
  const m = msg.toLowerCase();
  for (const [k, v] of Object.entries(BOT)) {
    if (m.includes(k)) return v;
  }
  return BOT.default;
}

function addMsg(text, role) {
  const c = document.getElementById('chatMessages');
  const div = document.createElement('div');
  div.className = 'msg ' + role;
  const html = text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  div.innerHTML = role === 'bot'
    ? `<div class="msg-avatar">AI</div><div class="msg-bubble">${html}</div>`
    : `<div class="msg-bubble">${html}</div>`;
  c.appendChild(div);
  c.scrollTop = c.scrollHeight;
}

function showTyping() {
  const c = document.getElementById('chatMessages');
  const div = document.createElement('div');
  div.className = 'msg bot'; div.id = 'typing-ind';
  div.innerHTML = `<div class="msg-avatar">AI</div><div class="chat-typing"><span></span><span></span><span></span></div>`;
  c.appendChild(div); c.scrollTop = c.scrollHeight;
}

function removeTyping() { const t = document.getElementById('typing-ind'); if (t) t.remove(); }

function sendChat() {
  const input = document.getElementById('chatInput');
  const msg = input.value.trim(); if (!msg) return;
  input.value = '';
  addMsg(msg, 'user');
  document.getElementById('quickReplies').style.display = 'none';
  showTyping();
  setTimeout(() => { removeTyping(); addMsg(getBotReply(msg), 'bot'); }, 800 + Math.random() * 600);
}

function quickSend(msg) { document.getElementById('chatInput').value = msg; sendChat(); }

// ─── SCROLL REVEAL ────────────────────────────────────────────────────────
const revObs = new IntersectionObserver((entries) => {
  entries.forEach((e, i) => {
    if (e.isIntersecting) setTimeout(() => e.target.classList.add('visible'), i * 80);
  });
}, { threshold: 0.05 });
document.querySelectorAll('.reveal').forEach(el => revObs.observe(el));

// ─── NAV SCROLL ───────────────────────────────────────────────────────────
window.addEventListener('scroll', () => {
  const nav = document.getElementById('main-nav');
  if (nav) nav.style.background = window.scrollY > 60
    ? 'rgba(10,10,10,0.97)'
    : 'rgba(10,10,10,0.92)';
});

// ─── TEMPLATE FILTER ─────────────────────────────────────────────────────
function filterTemplates(tag, btn) {
  document.querySelectorAll('.tpl-filter').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  document.querySelectorAll('.tpl-card').forEach(card => {
    const tags = card.dataset.tags || '';
    card.style.display = (tag === 'all' || tags.includes(tag)) ? '' : 'none';
  });
}

// ─── MOBILE MENU ─────────────────────────────────────────────────────────
function toggleMobileMenu() {
  const nav = document.getElementById('mobileNav');
  const btn = document.getElementById('navHamburger');
  const open = nav.classList.toggle('open');
  if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  nav.setAttribute('aria-hidden', open ? 'false' : 'true');
}
function closeMobileMenu() {
  const nav = document.getElementById('mobileNav');
  const btn = document.getElementById('navHamburger');
  nav.classList.remove('open');
  nav.setAttribute('aria-hidden', 'true');
  if (btn) btn.setAttribute('aria-expanded', 'false');
}

// Also add template bot response
BOT['template'] = 'We have 60+ pre-built integration templates! Popular pairs: SAP B1 ↔ Shopify, iVend ↔ Lazada, Business Central 365 ↔ WooCommerce, and more. Check the Integration Templates section on this page, or email demo@allsync.io for a custom pair. 🔗';

// ─── COOKIE CONSENT ──────────────────────────────────────────────────────
function acceptCookies() {
  try { localStorage.setItem('allsync_cookie_consent', 'accepted'); } catch (e) {}
  hideCookieBanner();
  document.dispatchEvent(new CustomEvent('allsync:consent', { detail: { status: 'accepted' } }));
}
function rejectCookies() {
  try { localStorage.setItem('allsync_cookie_consent', 'rejected'); } catch (e) {}
  hideCookieBanner();
  document.dispatchEvent(new CustomEvent('allsync:consent', { detail: { status: 'rejected' } }));
}
function hideCookieBanner() {
  const b = document.getElementById('cookieBanner');
  if (b) b.classList.remove('visible');
}
function openCookiePrefs() {
  const b = document.getElementById('cookieBanner');
  if (b) b.classList.add('visible');
}

// ─── INIT (cookie banner) ─────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', function () {
  // Show the cookie banner only if the visitor hasn't already decided
  let consent = null;
  try { consent = localStorage.getItem('allsync_cookie_consent'); } catch (e) {}
  const banner = document.getElementById('cookieBanner');
  if (banner && !consent) banner.classList.add('visible');
});
